<template>
  <v-card elevation="0">
    
    <v-card-text>
      <v-alert v-if="error" type="error" dense outlined>{{ error }}</v-alert>

      <v-skeleton-loader
        v-if="loading"
        type="table"
        :loading="loading"
      />

      <v-data-table
        v-else
        :headers="headers"
        :items="modifiedVersions"
        class="elevation-1"
        dense
        fixed-header
        height="70vh"
        :items-per-page="25"
        :sort-by="['_sortTs']"
        :sort-desc="[true]"
        show-expand
        :expanded.sync="expanded"
        item-key="_key"
      >
      <template v-slot:[`item.MevDate`]="{ item }">
          {{ ($fun.formatDateView(item.MevDate) + ' ' +$fun.formatTimeShortView(item.MevTime)) }}
        </template>

        <template v-slot:[`item.MevStatus`]="{ item }">
          <v-chip x-small :color="item.MevStatusColor" dark>
            {{ item.MevStatusName }}
          </v-chip>
        </template>

        <template v-slot:[`item.changeCount`]="{ item }">
          <v-chip
            x-small
            outlined
            :color="getChangeCount(item) ? 'primary' : 'grey'"
            class="change-badge"
            @click.stop="toggleExpanded(item)"
          >
            {{ getChangeCount(item) ? `${getChangeCount(item)} cambio(s)` : 'Sin cambios' }}
          </v-chip>
        </template>

        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length" class="py-3">
            <div v-if="item.changes && Object.keys(item.changes).length" class="changes-grid">
              <div
                v-for="(value, key) in item.changes"
                :key="key"
                class="changes-row"
              >
                <div class="changes-field">
                  <span class="font-weight-medium">{{ translateField(key) }}</span>
                </div>
                <div class="changes-old">
                  <v-chip x-small outlined color="grey" class="chip-text">
                    {{ value.old ?? 'Vacío' }}
                  </v-chip>
                </div>
                <div class="changes-arrow grey--text text--darken-1">
                  <v-icon small>mdi-arrow-right</v-icon>
                </div>
                <div class="changes-new">
                  <v-chip x-small outlined color="red" class="chip-text">
                    {{ value.new ?? 'Vacío' }}
                  </v-chip>
                </div>
              </div>
            </div>
            <div v-else class="grey--text text--darken-1">
              Sin cambios respecto a la versión anterior
            </div>
          </td>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-btn icon small @click="viewPdf(item)" :title="'Ver ficha clínica'">
                        <v-icon>mdi-file-eye</v-icon>
                    </v-btn>
        </template>
      </v-data-table>
    </v-card-text>
    <v-dialog v-model="pdfDialog" fullscreen transition="dialog-bottom-transition">
            <v-card style="overflow: hidden !important">
                <pdf-clinical-history
                    v-if="selectedHistoryForPdf"
                    :key="selectedHistoryForPdf.MehID || selectedHistoryForPdf.id || Math.random()"
                    :history="selectedHistoryForPdf"
                    @close="pdfDialog = false"
                />
            </v-card>
        </v-dialog>
  </v-card>
</template>

<script>
import HistoryRecordService from '@/services/HumanResource/HistoryRecordService';
import PdfClinicalHistory from './PdfClinicalHistory.vue';
export default {
  name: 'HistoryChangesView',
  components: {
        PdfClinicalHistory,
    },
  props: {
    mevId: {
      type: Number,
      required: true,
    },
    // Registro actual de HmnMedicalEvaluation (último estado)
    current: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      error: null,
      versions: [],
      modifiedVersions: [],
      selectedHistoryForPdf : null,
      pdfDialog : false,
      expanded: [],
      headers: [
        { text: 'Versión', value: 'MehID', sortable: true, width: 70 },
        { text: 'Fecha', value: 'MevDate', sortable: true, width: 120 },
        { text: 'Estado', value: 'MevStatus', sortable: false, width: 120 },
        { text: 'Cambios', value: 'changeCount', sortable: true, width: 140 },
        { text: 'Acciones', value: 'actions', sortable: false },
      ],
      fieldTranslations: {
        MevStatusName: 'Estado de la ficha',
        MevDescriptionAnamnesis: 'Tipo de anamnesis',
        MevDescriptionAnamnesis: 'Anamnesis',
        MevDescriptionDiagnosis: 'Diagnóstico(s)',
        MevDescriptionDiagnosis: 'Descripción del diagnóstico',
        MevDescriptionReevaluation: 'Reevaluación',
        TypeRecommendationsDescription: 'Recomendaciones',
        MevRecommendations: 'Detalle de recomendaciones',
        MevHasRiskFactors: 'Tiene factores de riesgo',
        MevRiskFactors: 'Factores de riesgo',
        MevDiet: 'Requiere dieta',
        MevPregnant: 'Gestante',
        MevHeartRate: 'Frecuencia cardiaca',
        MevBreathingFrecuency: 'Frecuencia respiratoria',
        MevTemperature: 'Temperatura',
        MevOxygenSaturation: 'Saturación de oxígeno',
        MevPASistol: 'PA sistólica',
        MevPADiastol: 'PA diastólica',
        MevSize: 'Talla',
        MevWeight: 'Peso',
        MevBMI: 'IMC',
        DocName: 'Médico que atendió',
        NurseName: 'Enfermera que atendió',
        MevDate: 'Fecha de atención',
        MevIndications: 'Indicaciones',
        MevVisualFarRightName: 'Agudeza visual lejana ojo derecho',
        MevVisualFarLeftName: 'Agudeza visual lejana ojo izquierdo',
        MevVisualFarRightLenseName: 'Agudeza visual lejana ojo derecho con lente',
        MevVisualFarLeftLenseName: 'Agudeza visual lejana ojo izquierdo con lente',
        MevVisualNearRightName: 'Agudeza visual cercana ojo derecho',
        MevVisualNearLeftName: 'Agudeza visual cercana ojo izquierdo',
        MevVisualNearRightLenseName: 'Agudeza visual cercana ojo derecho con lente',
        MevVisualNearLeftLenseName: 'Agudeza visual cercana ojo izquierdo con lente',
        MevIsAllergy: 'Tiene alergias',
        MevFoodAllergy: 'Alergias alimentarias',
        MevMedicationAllergy: 'Alergias a medicamentos',
      },
    };
  },
  mounted() {
    this.loadHistory();
  },
  methods: {
    async loadHistory() {
      this.loading = true;
      this.error = null;
      try {
        const resp = await HistoryRecordService.getHistoryChanges(this.mevId);
        if (resp && resp.status === 200) {
          this.versions = Array.isArray(resp.data) ? resp.data : [];
          this.computeModifiedVersions();
        }
      } catch (e) {
        console.error('Error al cargar historial de cambios', e);
        this.error = 'No se pudo cargar el historial de cambios.';
      } finally {
        this.loading = false;
      }
    },
    computeModifiedVersions() {
      // Clonar historial devuelto por el SP
      let list = Array.isArray(this.versions) ? [...this.versions] : [];
      
      // Agregar la versión actual (tabla HmnMedicalEvaluation) al final
      if (this.current) {        
        list.push(this.current);
      }

      if (!list.length) {
        this.modifiedVersions = [];
        return;
      }

      // Ordenar por MehID ascendente para comparar versión a versión
      const sorted = list.sort((a, b) => a.MehID - b.MehID);
      // Solo comparar estos campos
      const includeFields = [...new Set([
        'MevIsAllergy',
        'MevFoodAllergy',
        'MevMedicationAllergy',
        'MevStatusName',
        'MevDate',
        'MevDescriptionAnamnesis',
        'MevDescriptionDiagnosis',
        'MevDescriptionReevaluation',
        'TypeRecommendationsDescription',
        'MevRecommendations',
        'MevHasRiskFactors',
        'MevRiskFactors',
        'MevDiet',
        'MevPregnant',
        'MevHeartRate',
        'MevBreathingFrecuency',
        'MevTemperature',
        'MevOxygenSaturation',
        'MevPASistol',
        'MevPADiastol',
        'MevSize',
        'MevWeight',
        'MevBMI',
        'DocName',
        // Ojos
        'MevVisualFarRightName',
        'MevVisualFarLeftName',
        'MevVisualFarRightLenseName',
        'MevVisualFarLeftLenseName',
        'MevVisualNearRightName',
        'MevVisualNearLeftName',
        'MevVisualNearRightLenseName',
        'MevVisualNearLeftLenseName',
      ])];

      const dateFields = ['MevDate'];

      // Campos que realmente son flags SI/NO (no todos los numéricos 0/1)
      const booleanFields = [
        'MevHasRiskFactors',
        'MevDiet',
        'MevPregnant',
        'MevIsAllergy',
        'MevFoodAllergy',
        'MevMedicationAllergy',
        'MevIsTuberculosis',
        'MevIsChronicBronchitis',
        'MevIsSeizures',
        'MevIsDiabetes',
        'MevIsBloodPressure',
        'MevIsNeoplasm',
        'MevIsAsthma',
        'MevIsHepatitis',
        'MevIsEts',
      ];

      const result = [];

      for (let i = 0; i < sorted.length; i++) {
        const current = sorted[i];
        const previous = sorted[i - 1];
        const changes = {};

        if (previous) {
          includeFields.forEach((key) => {            
            const oldVal = previous[key];
            const newVal = current[key];

            if (oldVal === newVal) return; // sin cambio real

            let oldValue = oldVal;
            let newValue = newVal;

            // Fechas
            if (dateFields.includes(key)) {
              if (oldValue) oldValue = this.$fun.formatDateView(oldValue);
              if (newValue) newValue = this.$fun.formatDateView(newValue);
            }

            // Flags booleanos conocidos
            if (booleanFields.includes(key)) {
              const map = { 0: 'No', 1: 'Si' };
              oldValue = map[oldValue] ?? (oldValue == 0 ? 'No' : oldValue == 1 ? 'Si' : oldValue);
              newValue = map[newValue] ?? (newValue == 0 ? 'No' : newValue == 1 ? 'Si' : newValue);
            }

            changes[key] = { old: oldValue, new: newValue };
          });
        }

        // Key estable para la tabla/expand (la versión actual puede no traer MehID)
        const stableKey = current.MehID ?? current.SecRowVersion ?? `${i}-${current.MevDate ?? ''}-${current.MevTime ?? ''}`;

        // Sort numérico para ordenar por más reciente: fecha+hora o fallback por MehID
        let sortTs = 0;
        try {
          if (current.MevDate) {
            const datePart = new Date(current.MevDate);
            const timePart = current.MevTime ? String(current.MevTime) : '';
            const match = timePart.match(/(\d{1,2}):(\d{2})/);
            if (!isNaN(datePart.getTime())) {
              if (match) {
                datePart.setHours(Number(match[1]), Number(match[2]), 0, 0);
              }
              sortTs = datePart.getTime();
            }
          }
        } catch {
          // noop
        }
        if (!sortTs && current.MehID) sortTs = Number(current.MehID);

        result.push({ ...current, changes, _key: stableKey, _sortTs: sortTs });
      }

      // Mostrar más reciente primero (desc) sin romper el cálculo (que se hace asc)
      this.modifiedVersions = [...result].sort((a, b) => (b._sortTs ?? 0) - (a._sortTs ?? 0));
    },
    translateField(field) {
      return this.fieldTranslations[field] || field;
    },
    getChangeCount(item) {
      if (!item || !item.changes) return 0;
      return Object.keys(item.changes).length;
    },

    toggleExpanded(item) {
      const idx = this.expanded.indexOf(item);
      if (idx >= 0) {
        this.expanded.splice(idx, 1);
      } else {
        this.expanded.push(item);
      }
    },
    viewPdf(item) {
      this.selectedHistoryForPdf = item;
      this.pdfDialog = true;
    },
  },
};
</script>

<style scoped>
.changes-grid {
  display: grid;
  grid-template-columns: 1fr;
  row-gap: 6px;
}

.changes-row {
  display: grid;
  grid-template-columns: 220px 1fr 28px 1fr;
  column-gap: 8px;
  align-items: center;
}

.chip-text {
  max-width: 100%;
}

.change-badge {
  cursor: pointer;
}

/* Evita que textos muy largos rompan el layout */
::v-deep .chip-text .v-chip__content {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media (max-width: 900px) {
  .changes-row {
    grid-template-columns: 1fr;
    row-gap: 6px;
  }
  .changes-arrow {
    display: none;
  }
}
</style>
